import React from 'react';
import { Flex, Modal, Row, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { VertButton, VertTypography } from '@vertem-core/vertice-ds';

const ModalUploadJSON = ({ isOpen, setIsOpenModal, setLoading, onUpload }) => {
  const handleUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        setLoading(true);
        const json = JSON.parse(e.target.result);

        if (onUpload) onUpload(json);
        message.success(`${file.name} arquivo enviado com sucesso.`);
        setIsOpenModal(false);
      } catch (err) {
        setLoading(false);
        message.error(`${file.name} erro ao enviar arquivo.`);
      }
    };
    reader.readAsText(file);
    return false;
  };

  const uploadProps = {
    beforeUpload: handleUpload,
    accept: '.json',
    multiple: false,
    showUploadList: false,
  };

  return (
    <Modal
      open={isOpen}
      closable={false}
      onCancel={() => setIsOpenModal(false)}
      footer={[
        <Flex justify="center" align="center" key="footer">
          <VertButton
            key="back"
            onClick={() => setIsOpenModal(false)}
            type="highlight"
          >
            Cancelar
          </VertButton>
        </Flex>,
      ]}
    >
      <Row justify="center" key="footer">
        <VertTypography.Title level={4}>
          Faça o upload do arquivo da Skin JSON
        </VertTypography.Title>
        <Upload {...uploadProps}>
          <VertButton icon={<UploadOutlined />} type="default" block>
            Clique para fazer o upload do arquivo JSON.
          </VertButton>
        </Upload>
      </Row>
    </Modal>
  );
};

export default ModalUploadJSON;
